/* 🤖 this file was generated by svg-to-ts */
export const DfIconArrowForwardCircle16: {
  name: 'arrow-forward-circle-16';
  data: string;
} = {
  name: 'arrow-forward-circle-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4.779 9.91C6.044 9.058 7.12 8.671 8 9.376v1.13a.5.5 0 0 0 .85.354l3.004-2.51a.5.5 0 0 0 0-.707L8.85 5.15a.497.497 0 0 0-.85.353v.996c0 .276-.227.5-.503.5-1.539.22-2.665.958-3.427 2.241a.5.5 0 0 0 .709.67z"/></svg>`
};
